(() => {
  if (window.cvCollectionCountSync) return;

  const syncCount = () => {
    const grid = document.querySelector('[data-cv-filtered-product-count]');
    if (!grid) return;
    const count = grid.dataset.cvFilteredProductCount;
    if (!/^\d+$/.test(count || '')) return;

    document.querySelectorAll('[data-cv-collection-count]').forEach((label) => {
      const template = label.dataset.cvCountTemplate;
      if (!template) return;
      const text = template.replace(/\[N\]/g, count);
      if (label.textContent !== text) label.textContent = text;
    });

    const scale = document.querySelector('.sv-scoville-section--toggle');
    if (!scale) return;
    const active = [];
    scale.querySelectorAll('.sv-scoville__cell').forEach((cell) => {
      const value = new URL(cell.href).searchParams.get('filter.p.m.custom.heat_level');
      const input = Array.from(grid.querySelectorAll('input[name="filter.p.m.custom.heat_level"]'))
        .find((option) => option.value === value);
      if (!input) return;
      const number = input.closest('label')?.querySelector('.m-facet--product-count')?.textContent.match(/\d+/)?.[0];
      const name = cell.querySelector('.sv-scoville__label')?.textContent.trim();
      if (number !== undefined && cell.querySelector('.sv-scoville__count')) {
        cell.querySelector('.sv-scoville__count').textContent = number;
      }
      cell.classList.toggle('is-active', input.checked);
      if (input.checked) {
        cell.setAttribute('aria-current', 'true');
        active.push(name);
      } else {
        cell.removeAttribute('aria-current');
      }
      cell.setAttribute('aria-label', `${name}${number !== undefined ? ` — ${number} varieties` : ''}${input.checked ? ', currently filtered' : ''}`);
    });
    const state = scale.querySelector('.sv-scoville__filter-state');
    if (state) {
      state.style.display = active.length ? '' : 'none';
      state.querySelector('.sv-scoville__filter-chip').textContent = `Filtered: ${active.join(', ')}`;
    }
  };

  window.cvCollectionCountSync = true;
  document.addEventListener('collection:rerendered', syncCount);
  document.addEventListener('shopify:section:load', syncCount);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncCount, { once: true });
  } else {
    syncCount();
  }
})();
